import { useEffect, useState } from "react";
import { DayModal } from "./day_modal";

const config = {
  transport: {
    fly: { icon: "fas fa-plane", label: "Fly" },
    fly_out: { icon: "fas fa-plane-departure", label: "Fly out" },
    fly_in: { icon: "fas fa-plane-arrival", label: "Fly in" },
    car: { icon: "fas fa-car-side", label: "Car" },
    bus: { icon: "fas fa-bus", label: "Bus" },
    train: { icon: "fas fa-train", label: "Train" },
    boat: { icon: "fas fa-ship", label: "Boat" },
  },
  accommodation: {
    hotel: { icon: "fas fa-hotel", label: "Hotel" },
    house: { icon: "fas fa-home", label: "House" },
    camping: { icon: "fas fa-campground", label: "Camping" },
  },
  weather: {
    sun: { icon: "bi bi-sun-fill", label: "Sun" },
    cloud: { icon: "fas fa-cloud", label: "Cloud" },
    rain: { icon: "fas fa-umbrella", label: "Rain" },
    cold: { icon: "fas fa-snowflake", label: "Cold" },
  },
};

function useIsMobile(breakpoint = 800) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);
  return isMobile;
}

export const Calendar = ({ trip }) => {
  const [selectedDayIndex, setSelectedDayIndex] = useState(null);
  const calendar = trip?.calendar || [];
  const isMobile = useIsMobile(800);
  const flatDays = calendar.flat().filter((x) => x);

  if (isMobile) {
    return (
      <div>
        {flatDays.map((day) => (
          <div className="border mv-3" key={day.index}>
            <DayBox day={day} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="calendar-container">
      <table className="calendar">
        <thead>
          <tr>
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
              <th key={day}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {calendar.map((week, wIdx) => (
            <tr key={wIdx}>
              {week.map((day, dIdx) => (
                <td
                  className={day ? "pointer" : "empty"}
                  key={dIdx}
                  onClick={() => setSelectedDayIndex(day.index)}
                >
                  {day && <DayBox day={day} />}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {selectedDayIndex !== null && (
        <DayModal
          trip={trip}
          days={flatDays}
          day={flatDays[selectedDayIndex]}
          close={() => setSelectedDayIndex(null)}
          setDay={setSelectedDayIndex}
        />
      )}
    </div>
  );
};

const DayBox = ({ day }) => {
  const isMobile = useIsMobile(800);

  return (
    <div className="calendar-day-cell">
      <div className="day-short">
        {isMobile && <span className="mr-1">{day.day_of_the_week},</span>}
        {day.day_short}
      </div>
      {day.summary && <div className="summary mt-2">{day.summary}</div>}
      {day.weathers.length > 0 && (
        <div className="weather mt-2">
          {day.weathers.map((weather, i) => (
            <div key={i} className="d-flex align-items-center">
              <i
                className={`${config.weather[weather.type].icon} mr-1`}
                title={weather.name}
              />
            </div>
          ))}
        </div>
      )}
      {day.transports.length + day.accommodations.length > 0 && (
        <>
          <div className="icons mt-2">
            {day.transports.map((transport, i) => (
              <i
                key={`t-${i}`}
                className={`${config.transport[transport.type].icon} mr-1`}
                title={transport.name}
              />
            ))}

            {day.accommodations.map((accommodation, i) => (
              <i
                key={`a-${i}`}
                className={`${config.accommodation[accommodation.type].icon} mr-1`}
                title={accommodation.name}
              />
            ))}
          </div>
        </>
      )}

      {day.activities && day.activities.length > 0 && (
        <ul className="activities w-100 text-start">
          {day.activities.map((activity, i) => (
            <li className="my-1" key={i}>
              {activity.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
